import moduleConfig from "./checkout.config";

export default [
	{
		path: moduleConfig.basePath,
		component: () => import("./checkout.module"),
		children: [
			{
				path: "/",
				name: "checkout",
				component: () => import("./views/checkout"),
			},
			{
				path: "/order-success/:orderId",
				name: "order-success",
				component: () => import("./views/order-success"),
			},
			{
				path: "/order-verify",
				name: "order-verify",
				component: () => import("./views/verify-order"),
			},
		],
	},
];
